import { render, staticRenderFns } from "./DialogShare.vue?vue&type=template&id=24268596&scoped=true&lang=pug"
import script from "./DialogShare.vue?vue&type=script&lang=js"
export * from "./DialogShare.vue?vue&type=script&lang=js"
import style0 from "./DialogShare.vue?vue&type=style&index=0&id=24268596&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24268596",
  null
  
)

export default component.exports